export const firebaseConfig = {
  apiKey: "AIzaSyDBC51dBeaNfw-oX7KWMwRM76dH1mrSSDs",
  authDomain: "csspressme.firebaseapp.com",
  databaseURL: "https://csspressme.firebaseio.com",
  projectId: "csspressme",
  storageBucket: "csspressme.appspot.com",
  messagingSenderId: "343572117702",
  appId: "1:343572117702:web:56cff763adb3575deb3fc7",
  measurementId: "G-5FLW05KR0P"
};